import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import hospitalsReducer from './hospitalSlice';
import studiesReducer from './studySlice';
import patientsReducer from './patientsSlice';
import usersReducer from './usersSlice';
import eventsReducer from './eventsSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    studies: studiesReducer,
    hospitals: hospitalsReducer,
    patients: patientsReducer,
    users: usersReducer,
    events: eventsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
